import { render, staticRenderFns } from "./Kumppanit.vue?vue&type=template&id=84d36dae&"
import script from "./Kumppanit.vue?vue&type=script&lang=js&"
export * from "./Kumppanit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports